// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3elrm","delete":"styles_delete__-gNVU","update":"styles_update__1Etpd","add":"styles_add__3HORv"};